import { render } from "./CustomMultiSelect.vue?vue&type=template&id=460c11c7&scoped=true"
import script from "./CustomMultiSelect.vue?vue&type=script&lang=js"
export * from "./CustomMultiSelect.vue?vue&type=script&lang=js"

import "./CustomMultiSelect.vue?vue&type=style&index=0&id=460c11c7&lang=less&scoped=true"

import exportComponent from "/home/rampa/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-460c11c7"]])

export default __exports__